var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-input",class:{ 
    'form-input--full': _vm.isFull, 
    'form-input--error': _vm.error,
    'form-input--disabled': _vm.disabled,
  }},[_c('input',{attrs:{"type":_vm.type,"disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onChange}}),_c('span',{staticClass:"form-input__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }